module.exports = __webpack_public_path__ + "static/quebec-9d4f68ccab600ebb8e0191932639894a.png";